import styled from 'styled-components'
import { CLIENT_STYLINGS } from '../../../../utils/constants'
import { getBorderRadius, getShadow } from '../../../../utils/styleUtils'

export const GridWrapper = styled.div`
  background-color: transparent;
  width: 100%;
`

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const GridItemWrapper = styled.a`
  width: 100%;
  display: block;
  text-decoration: none;
`

export const GridItemDetailsWrapper = styled.div`
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  border-radius: ${props => getBorderRadius(props, 'lg')};
  box-shadow: ${props => getShadow(props, 'sm')};
  overflow: hidden;
  display: grid;
  grid-template-columns: calc((128px - 24px) * 1.7) 1fr 32px;
  align-items: stretch;
  column-gap: 16px;
  padding: 12px;
  height: 128px;

  &:hover {
    cursor: pointer;
  }
`

export const ItemImageWrapper = styled.div`
  height: 100%;
  min-height: 0;
`

export const ItemImage = styled.div`
  position: relative;
  height: 100%;
  min-height: 0;
  border-radius: ${props => getBorderRadius(props, 'md')};
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url(${({ backgroundImage }) =>
        `"${encodeURI(backgroundImage)}"`}),
      url(${({ backgroundImage }) => `"${backgroundImage}"`});
    background-size: cover;
    background-position: center;
    transition: transform 0.25s ease;
    will-change: transform;
  }

  ${GridItemDetailsWrapper}:hover &::before {
    transform: scale(1.06);
  }
`

export const TripDetailsWrapper = styled.div`
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const TripSecondaryDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const TripSecondaryDetailsItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`

export const RelevancyInfo = styled.span`
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  line-height: 15px;
  padding: 2px 5px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
`

export const TripSecondaryDetails = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 16px;
  font-weight: 400;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  line-height: 18px;
`

export const TitleWrapper = styled.div`
  width: fit-content;
  padding: 0;
  text-align: left;
`

export const Title = styled.h3`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 20px;
  font-weight: 700;
  color: #4d7aa9;
  padding: 0;
  margin: 0;
  text-align: left;
  text-transform: none;
  transition: color 0.2s ease;
  line-height: 24px;

  ${GridItemDetailsWrapper}:hover & {
    color: #333333;
  }
`

export const RatingImageWrapper = styled.div`
  width: fit-content;
`

export const RatingImage = styled.img`
  height: 22px;
  width: auto;
`

export const Location = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 16px;
  color: #333;
  line-height: 24px;
  font-weight: 400;
  text-transform: none;
  text-align: left;
  align-self: flex-start;
`

export const LabelBottomWrapper = styled.div`
  width: fit-content;
  padding: 0;
`

export const LabelBottom = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 16px;
  font-weight: 400;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  text-transform: capitalize;
`

export const BottomRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
  width: 100%;
`

export const DurationGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const DurationIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #999999;
`

export const DurationText = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 16px;
  color: #999999;
  line-height: 20px;
`

export const PriceText = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 28px;
  font-weight: 700;
  color: #4e4351;
  transition: color 0.2s ease;
  line-height: 30px;

  ${GridItemDetailsWrapper}:hover & {
    color: #4d7aa9;
  }
`

export const PriceSuffix = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 16px;
  font-weight: 400;
  color: #999999;
  margin-left: 6px;
  line-height: 18px;
`

export const PriceGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 6px;
  margin-left: auto;
`

export const ChevronWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
`

export const GridTitle = styled.h2`
  position: inherit;
  background-color: unset;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-size: 20px;
  line-height: 30px;
  font-weight: 800;
  margin: 20px 0 15px;
  text-transform: uppercase;
  text-align: ${props => {
    return props?.isChatMode ? 'center' : 'left'
  }};
`

export const ShowMoreCta = styled.button`
  display: flex;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 7px 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  margin: 15px auto;
`
